import React, { useState, useRef, useEffect } from "react";
import cn from "classnames";
import { RichText } from "@/components/atoms";
import {
  textBodyInverse,
  textBodyNeutral,
  marginTXS,
  marginTMd,
} from "@/constants/standardCSSClasses";
import { CustomButtonInterface } from "@/components/molecules/CustomButton";
import CustomButtonGroup from "@/components/molecules/CustomButtonGroup";
import { CustomImageInterface } from "@/components/molecules/CustomImage";
import CustomMedia, {
  MediaObjectInterface,
} from "@/components/molecules/CustomMedia";

interface Props {
  content?: string;
  variant: string;
  open: boolean;
  isMobile: boolean;
  button: CustomButtonInterface;
  image: CustomImageInterface;
  media?: MediaObjectInterface;
}

export default function FeaturesInteractiveItem({
  content = "",
  variant = "white",
  open = false,
  isMobile,
  button,
  image,
  media = {
    type: "image",
    media: {},
  },
}: Props) {
  const [contentHeight, setContentHeight] = useState("");
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(`${contentRef.current.scrollHeight + 32}px`);
    }
  }, [open]);

  const pTextClassNames = cn(marginTXS, {
    [textBodyInverse]: variant === "dark",
    [textBodyNeutral]: variant !== "dark",
  });

  const contentClassNames = cn("transition-all duration-500 overflow-hidden", {
    "max-h-0 opacity-0": !open,
  });

  const contentStyle = open ? { maxHeight: contentHeight } : {};

  const buttons = [];

  if (button.href) {
    buttons.push({
      ...button,
      variant: variant,
      size: "md",
      textOnly: true,
      arrow: true,
    });
  }

  return (
    <div ref={contentRef} className={contentClassNames} style={contentStyle}>
      <RichText className={pTextClassNames} tag="p">
        {content}
      </RichText>
      {button.href && (
        <CustomButtonGroup
          marginTop={marginTMd}
          align="left"
          buttons={buttons}
          mobileWide={false}
        />
      )}
      {isMobile && (
        <CustomMedia
          className={cn(marginTMd)}
          media={media ?? { media: {}, type: "image" }}
          aspect="423:331"
          fallbackImage={image}
        />
      )}
    </div>
  );
}
